<template>
<el-card :class="$style.myelcard" shadow="hover">
	<div class="dflex fw500">
		<div class="f1">
			<div :class="$style.pic">
				<img v-show="videoId != ''" :class="$style.playerButton" src="../assets/youtube.png"  @click="playYoutubeVideo" >
				<img :src="item['head_portrait']" alt=""  :class="$style.img">
			</div>
			<div class="fs1 gray" :class="$style.lb">
				<div class="dflex" style="margin: 8px 0px 5px;" :class="$style.fs">
					<!-- <div @mouseover="hoverHeart = true" @mouseout="hoverHeart = false">
						<img :src="hearturl" class="cp" @click="onClickFavorite" :class="$style.heart">
					</div> -->
					<div>
						<el-checkbox :label="interName" :checked="item.is_favorite == 1" @change="onClickFavorite"></el-checkbox>
					</div>
					<!-- <span style="padding-left: 10px;">{{ $t('favorite11') }}</span> -->
					<span class="f1 right"><el-link type="primary" @click="onDetailClick">{{$t('more')}}>></el-link></span>
				</div>
				<div class="dflex" :class="$style.fs">
					<span style="margin-left: 28px;">{{$t('status')}}</span>
					<span class="f1"></span>
					<span :class="$style.state" :notavail="!item['available_status']" class="white fs14" style="padding: 0px 10px;border-radius: 5px;">{{!!item['available_status'] ? $t('available') : $t('notavailable')}}</span>
				</div>
			</div>
		</div>
		<div :class="$style.right">
			<p v-for="item in list" :key="item.label" class="dflex" style="margin-bottom: 0.5rem;">
				<span class="f1 gray">{{item.label}}</span><span class="gray">:</span>
				<span :class="$style.value">{{item.value}}</span>
			</p>
		</div>
	</div>
</el-card>
</template>
<script>
import heart from '../assets/heart1.svg';
import heartred from '../assets/heartred.svg';

export default {
    name: 'Card',
    props: {
        item: { type: Object, default: () => ({}) },
		showDialogFunc:{type: Function, default: () => {}},
    },
	// emit:[''],
    data() {
        return {
            // hearturl: ''
            heart,
            heartred,
            hoverHeart: false,
			interName:this.$t('interview'),
			videoId:this.item['youtube_video_id'],
        }
    },
    computed: {
        hearturl() {
            if (this.hoverHeart) {
                return heartred;
            }
            return this.item['is_favorite'] ? heartred : heart;
        },
        list() {
            return [
                {label: this.$t('code'), value: this.item.code},
                {label: this.$t('name1'), value: this.item.name},
                {label: this.$t('age'), value: this.item.age},
                {label: this.$t('birth'), value: this.item.birthday},
                // {label: this.$t('constellation'), value: this.item.constellation || ''},
                {label: this.$t('zodiac'), value: this.item.zodiac},
                {label: this.$t('marriage'), value: this.item.marriage},
                {label: this.$t('kids'), value: this.item.kids},
                {label: this.$t('st1'), value: this.item['first_love']},
                {label: this.$t('st2'), value: this.item['second_love']},
                {label: this.$t('st3'), value: this.item['third_love']},
                {label: this.$t('religion'), value: this.item['religion']},
            ];
        },
    },
    methods: {
		playYoutubeVideo(){
			this.$emit('setYoutubeVideoId',this.videoId)
		},
        // onClickFavorite() {
        //     this.$service.markFavorite({code: this.item.code}).then(() => {
        //         this.$set(this.item, 'is_favorite', !this.item['is_favorite']);
        //         this.$forceUpdate();

        //     });
        // },
		onClickFavorite() {
		    this.$service.markInterview({code: this.item.code}).then(() => {
		        this.$set(this.item, 'is_favorite', !this.item['is_favorite']);
		        this.$forceUpdate();
				if(this.item['is_favorite'] == 1) {
					this.showDialogFunc();
				}
		    });
		},
		
        onDetailClick() {
            this.$router.push('/detail/' + this.item.code);
			// let  toTaskLog = this.$router.resolve({path: '/detail/' + this.item.code});
			// window.open(toTaskLog.href,'_blank');
        },
    }
}
</script>
<style module>

.state {
    background: #29bd7a;
}
.state[notavail] {
    background: #ec2626;
}
.pic {
    width:200px;
    height:270px;
	position: relative;
}
.playerButton {
	width: 2.5rem;
	height: 2.5rem;
	position: absolute;
	left: 10px;
	bottom: 10px;
	cursor: pointer;
}
.right {
    font-size: 18px;
    line-height: 1.5;
    flex:1.5;
    padding-left: 20px;
    margin-right: 50px;
}
.value {
    flex: 1.5;
    padding-left: 10px;
}
.lb {
    width: 200px;
}
.heart {
    vertical-align: -3px;
    width:18px;
}
.img {
    width: 200px;
    height: 270px;
}
@media screen and (max-width: 770px) {
	.f1{
		flex: 0;
	}
    .pic {
        width:150px;
        height:200px;
    }
    .img {
        width: 150px;
        height:200px;
    }
    .right {
        font-size: 12px;
        flex:1.5;
        padding-left: 10px;
        margin-right: 0px;
    }
    .value {
        flex: 1;
    }
    .lb {
        width: 150px;
		margin-top: 100px;
    }
    .fs {
        font-size: 12px;
    }
}
</style>
